export default function getWindowHeightOnPercentage(
    percentage: number,
): number {
    if (Number.isNaN(Number(percentage))) {
        return 0;
    }
    return Math.ceil((window.innerHeight / 100) * percentage);
}
